import React from 'react';
import ProjectsGraphQlController from '../../../../controllers/projectsGraphQl';
import { gql } from '@apollo/client';
import _ from 'lodash';
import service from '../../../../services/graphQlServices';
import LoadingBar from '../../../components/global/loadingBar';
import { ReactComponent as MoreVerticalIcon } from '../../../../assets/svg/Project/more-vertical.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
import { ReactComponent as AttachmentIcon } from '../../../../assets/svg/attachment.svg';
import { ReactComponent as PlusIcon } from '../../../../assets/svg/plus-gray.svg';
import { withRouter } from '../../../../services/withRoute';
import InputHeader from '../../global/inputwithHeader';
import ShowFileModal from './showFileModal';
import CustomDateInput from '../../global/customDateInput';
import Modal from '../../../components/modals';
import Select, { components } from 'react-select';
import Dropzone from 'react-dropzone';
import DatePicker from 'react-datepicker';
import jwt_decode from 'jwt-decode';
import { Document, Page, pdfjs } from 'react-pdf';
import moment from 'moment';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
var randomize = require('randomatic');
const prettyBytes = require('pretty-bytes');

const getExpense = gql`
	query VendorExpense($workspaceId: String!, $vendorExpenseId: ID!, $projectId: ID) {
		vendorExpense(workspaceId: $workspaceId, id: $vendorExpenseId, projectId: $projectId) {
			id
			projectId
			eventId
			amount
			currency
			description
			type
			billDate
			billTo
			spentBy
			metaData
			notes {
				_id
				createdAt
				createdBy
				message
				updatedAt
				updatedBy
			}
			files {
				_id
				fileType
				originalFileName
				s3KeyOriginal
				originalFileSizeInMb
				uploadSource
			}
		}
	}
`;

const detachFileFromExpense = gql`
	mutation DetachFileFromVendorExpense(
		$workspaceId: String!
		$fileId: ID!
		$detachFileFromVendorExpenseId: ID
		$projectId: ID
	) {
		detachFileFromVendorExpense(
			workspaceId: $workspaceId
			fileId: $fileId
			id: $detachFileFromVendorExpenseId
			projectId: $projectId
		) {
			id
			files {
				_id
				fileType
				originalFileName
				s3KeyOriginal
				originalFileSizeInMb
			}
		}
	}
`;

const detachProjectFileFromExpense = gql`
	mutation DetachFileFromExpense($detachFileFromExpenseId: ID!, $projectId: ID, $fileId: ID!) {
		detachFileFromExpense(
			id: $detachFileFromExpenseId
			projectId: $projectId
			fileId: $fileId
		) {
			id
			files {
				_id
				fileType
				originalFileName
				s3KeyOriginal
				originalFileSizeInMb
			}
		}
	}
`;

const attachFileToExpense = gql`
	mutation AttachFileToExpense(
		$workspaceId: String!
		$files: [DeNormalizedFileInput!]!
		$projectId: ID
		$attachFileToExpenseId: ID
	) {
		attachFileToExpense(
			workspaceId: $workspaceId
			files: $files
			projectId: $projectId
			id: $attachFileToExpenseId
		) {
			id
			files {
				_id
				fileType
				originalFileName
				s3KeyOriginal
				originalFileSizeInMb
			}
		}
	}
`;

const uploadProjectFile = gql`
	mutation UploadVendorFile($branchId: String!, $uploadInput: FileUploadInput!) {
		uploadVendorFile(branchId: $branchId, uploadInput: $uploadInput) {
			signedUrl
			fileId
		}
	}
`;

const getFileSignedUrl = gql`
	query RootQuery($workspaceId: ID!, $branchId: ID!, $fileId: ID!) {
		getVendorFileSignedUrl(workspaceId: $workspaceId, branchId: $branchId, fileId: $fileId)
	}
`;

const getProjectFileSignedUrl = gql`
	query RootQuery($workspaceId: ID!, $projectId: ID!, $fileId: ID!) {
		getProjectFileSignedUrl(workspaceId: $workspaceId, projectId: $projectId, fileId: $fileId)
	}
`;

const getFileUploadStatus = gql`
	query BranchFileUploadStatus($branchId: String!, $uploadBatchId: String) {
		branchFileUploadStatus(branchId: $branchId, uploadBatchId: $uploadBatchId) {
			uploadedCount
			filesUploaded {
				_id
				fileType
				originalFileName
				s3KeyOriginal
				originalFileSizeInMb
			}
		}
	}
`;

const getProjectList = gql`
	query VendorsProjects($filters: projectsListFiltersInput, $workspaceIds: [String!]) {
		vendorsProjects(filters: $filters, workspaceIds: $workspaceIds) {
			hasNextPage
			data {
				id
				title
			}
		}
	}
`;

const getSingleProject = gql`
	query VendorsProject($workspaceId: String!, $projectId: ID!) {
		vendorsProject(workspaceId: $workspaceId, projectId: $projectId) {
			id
			title
		}
	}
`;

const addExpense = gql`
	mutation AddExpenseFromVendor($workspaceId: ID!, $projectId: ID!, $expenseInput: ExpenseInput) {
		addExpenseFromVendor(
			workspaceId: $workspaceId
			projectId: $projectId
			expenseInput: $expenseInput
		) {
			id
		}
	}
`;
const saveExpense = gql`
	mutation UpdateExpenseFromVendor(
		$workspaceId: ID!
		$projectId: ID!
		$updateExpenseFromVendorId: ID!
		$expenseInput: ExpenseInput
	) {
		updateExpenseFromVendor(
			workspaceId: $workspaceId
			projectId: $projectId
			id: $updateExpenseFromVendorId
			expenseInput: $expenseInput
		) {
			id
		}
	}
`;
const deleteExpense = gql`
	mutation DeleteExpenseFromVendor(
		$workspaceId: ID!
		$projectId: ID!
		$deleteExpenseFromVendorId: ID!
	) {
		deleteExpenseFromVendor(
			workspaceId: $workspaceId
			projectId: $projectId
			id: $deleteExpenseFromVendorId
		) {
			acknowledged
			deletedId
		}
	}
`;
const addExpenseNote = gql`
	mutation AddExpenseNote(
		$workspaceId: String!
		$addExpenseNoteId: ID!
		$projectId: ID
		$noteInput: NoteInput
	) {
		addExpenseNote(
			workspaceId: $workspaceId
			id: $addExpenseNoteId
			projectId: $projectId
			noteInput: $noteInput
		) {
			notes {
				_id
				createdAt
				createdBy
				message
				updatedAt
				updatedBy
			}
		}
	}
`;
const deleteExpenseNote = gql`
	mutation DeleteExpenseNote(
		$workspaceId: String!
		$deleteExpenseNoteId: ID!
		$noteId: ID!
		$projectId: ID
	) {
		deleteExpenseNote(
			workspaceId: $workspaceId
			id: $deleteExpenseNoteId
			noteId: $noteId
			projectId: $projectId
		) {
			notes {
				_id
				message
				createdBy
				createdAt
				updatedBy
				updatedAt
			}
		}
	}
`;
const updateExpenseNote = gql`
	mutation UpdateExpenseNote(
		$workspaceId: String!
		$updateExpenseNoteId: ID!
		$noteId: ID!
		$projectId: ID
		$noteInput: UpdateNoteInput
	) {
		updateExpenseNote(
			workspaceId: $workspaceId
			id: $updateExpenseNoteId
			noteId: $noteId
			projectId: $projectId
			noteInput: $noteInput
		) {
			notes {
				_id
				message
				createdBy
				createdAt
				updatedBy
				updatedAt
			}
		}
	}
`;

const getEventsList = gql`
	query VendorEventsList($filters: VendorEventsListFiltersInput) {
		vendorEventsList(filters: $filters) {
			hasNextPage
			data {
				id
				name
				childEvents {
					_id
					name
				}
			}
		}
	}
`;

const getEvent = gql`
	query VendorEvent($projectId: ID!, $vendorEventId: ID!, $workspaceId: String!) {
		vendorEvent(projectId: $projectId, id: $vendorEventId, workspaceId: $workspaceId) {
			id
			crew {
				count
				role
				managerIds
				subRole
				userIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
		}
	}
`;

class CreateExpense extends ProjectsGraphQlController {
	constructor(props) {
		super(props);
		this.state = {
			showAddEditModal: false,
			showDiscardModal: false,
			isExpensesLoading: true,
			expenseDetails: {},
			projectNameOptions: [{ value: null, label: 'Select' }],
			projectsNameList: [],
			eventNameOptions: [{ value: null, label: 'Select' }],
			activeExpenseID: null,
			billDate: parseInt(moment().format('YYYYMMDD')),
			bookingID: null,
			bookingIDError: false,
			bookingIDErrorMessage: '',
			numberOfTravellers: 1,
			numberOfTravellersError: false,
			numberOfTravellersErrorMessage: '',
			bookedVia: 'MMT',
			bookedViaOptions: [{ value: 'MMT', label: 'MMT' }],
			travelDate: parseInt(moment().format('YYYYMMDD')),
			travelFrom: null,
			travelFromError: false,
			travelFromErrorMessage: '',
			travelTo: null,
			travelToError: false,
			travelToErrorMessage: '',
			ticketPrice: 0,
			ticketPriceError: false,
			ticketPriceErrorMessage: '',
			refundAmount: 0,
			refundAmountError: false,
			refundAmountErrorMessage: '',
			metaNotes: '',
			lossAmount: 0,
			status: null,
			statusOptions: [
				{ value: null, label: 'Select' },
				{ value: 'booked', label: 'Booked' },
				{ value: 'cancelled', label: 'Cancelled' },
			],
			amount: 0,
			type: null,
			spentBy: null,
			description: null,
			currency: 'inr',
			billTo: null,
			referenceId: null,
			newAddedNote: [],
			notes: [],
			categoryOptions: [
				{ value: 'food', label: 'Food' },
				{ value: 'travel', label: 'Travel' },
				{ value: 'equipment', label: 'Equipment' },
				{ value: 'accomodation', label: 'Accomodation' },
				{ value: 'travelBus', label: 'Travel Bus' },
				{ value: 'travelFlight', label: 'Travel Flight' },
				{ value: 'rent', label: 'Rent' },
				{ value: 'electricity', label: 'Electricity' },
				{ value: 'internet', label: 'Internet' },
				{ value: 'salaries', label: 'Salaries' },
				{ value: 'freelancers', label: 'Freelancers' },
				{ value: 'officeSupplies', label: 'Office supplies' },
				{ value: 'software', label: 'Software' },
				{ value: 'emi_loan', label: 'EMI / Loan' },
				{ value: 'other', label: 'Others' },
			],
			billedToOptions: [
				{ value: 'company', label: 'Us' },
				{ value: 'client', label: 'Client' },
			],
			editExpenseDetails: [],
			editExpenseAmountError: false,
			showDropDown: false,
			showDeleteConfirmationModal: false,
			tenantUsersList: {},
			tenantUsersListOptions: [],
			imageSrc: [],
			files: [],
			storedNote: '',
			limit: 10,
			page: 1,
			hasNextPage: true,
			eventLimit: 10000,
			eventPage: 1,
			hasNextEventsPage: true,
			eventId: _.has(props.params, 'shootID') ? props.params.shootID : null,
			isProjectsLoading: true,
			isEventsLoading: true,
			isReadyFilesLoaded: false,
			isFileLoading: false,
			readyToUploadFiles: [],
			uploadFileType: '',
			uploadFileType2: null,
			currentTab: 'details',
			isUploadComplete: false,
			showFileFile: {},
			showFileModal: false,
			showFileSrc: null,
			fileUpload: [],
			uploadBatchId: randomize('Aa0', 11),
			projectId: props.projectId,
			uploadFileErrorCount: 0,
			totalSignedUrlErrorCount: 0,
			disabledBtn: false,
			expenseType: 'shoot',
			expenseTypeOptions: [
				{ value: 'shoot', label: 'Shoot Expense' },
				{ value: 'workspace', label: 'Workspace Expense' },
			],
			spentByOptions: [],
			eventsNameList: [],
		};
		this.dropdownref = React.createRef();
	}
	timer = null;

	statusOption = (props) => {
		return (
			<div className="cost-select-custom-input-container">
				<span
					className={
						'status ' +
						(props.label === 'paid'
							? 'status-paid'
							: props.label === 'overdue'
							? 'status-overdue'
							: props.label === 'upcoming'
							? 'status-upcoming'
							: 'status-unscheduled')
					}
				></span>
				<components.Option {...props} />
			</div>
		);
	};

	statusValueContainer = (props) => {
		return (
			<div className="select-custom-value-container">
				<span
					className={
						'priority-icn status ' +
						(props.selectProps.value.label === 'paid'
							? 'status-paid'
							: props.selectProps.value.label === 'overdue'
							? 'status-overdue'
							: props.selectProps.value.label === 'upcoming'
							? 'status-upcoming'
							: 'status-unscheduled')
					}
					style={{ margin: '7px' }}
				></span>
				<components.ValueContainer {...props} />
			</div>
		);
	};

	componentDidMount = async () => {
		moment.relativeTimeThreshold('s', 60);
		moment.relativeTimeThreshold('m', 60);
		moment.relativeTimeThreshold('h', 24);
		moment.relativeTimeThreshold('d', 7);
		moment.relativeTimeThreshold('w', 4);
		moment.relativeTimeThreshold('M', 12);

		let userToken = localStorage.getItem('usertoken');
		let decoded = jwt_decode(userToken);

		let tenantUsersList = [...this.props.tenantUsersList];
		let tenantUsersListOptions = [];
		_.forEach(tenantUsersList, (user, key) => {
			let arr = [];
			arr.push({
				label: user.firstName + (user.lastName ? ' ' + user.lastName : ''),
				value: user.id,
			});
			return tenantUsersListOptions.push(arr[0]);
		});

		if (this.props.activeExpenseID !== null) {
			const expenseVariables = {
				projectId: _.has(this.props.params, 'projectID')
					? this.props.params.projectID
					: this.props.projectId,
				vendorExpenseId: this.props.activeExpenseID,
				workspaceId: this.props.params.workspaceID,
			};
			let response = await this.getExpense(getExpense, expenseVariables);
			if (response !== false) {
				let expenseDetails = {};
				expenseDetails = response;
				if (
					response.metaData === null ||
					response.metaData === {} ||
					response.metaData === undefined
				) {
					response['metaData'] = {};
					response['metaData']['bookingID'] = null;
					response['metaData']['numberOfTravellers'] = null;
					response['metaData']['bookedVia'] = null;
					response['metaData']['travelDate'] = null;
					response['metaData']['from'] = null;
					response['metaData']['to'] = null;
					response['metaData']['status'] = null;
					response['metaData']['ticketPrice'] = null;
					response['metaData']['notes'] = null;
					response['metaData']['refundAmount'] = null;
					response['metaData']['lossAmount'] = null;
				}
				let count = 0;
				while (count < _.size(expenseDetails.files)) {
					let getSignedUrlVariables = {
						fileId: expenseDetails.files[count]._id,
						workspaceId: this.props.params.workspaceID,
					};

					if (expenseDetails.files[count].uploadSource === 'vendor') {
						getSignedUrlVariables['branchId'] = 'VEHYD';
					} else {
						getSignedUrlVariables['projectId'] = this.props.params.projectID;
						getSignedUrlVariables['workspaceId'] = this.props.params.workspaceID;
					}

					let res = await this.getFileSignedUrl(
						expenseDetails.files[count].uploadSource === 'vendor'
							? getFileSignedUrl
							: getProjectFileSignedUrl,
						getSignedUrlVariables,
						null,
						expenseDetails.files[count].uploadSource === 'vendor' ? 'vendors' : null,
					);
					if (res !== false) {
						expenseDetails.files[count].src = res;
					}

					count = count + 1;
				}
				this.setState({
					eventId: expenseDetails.eventId,
					projectId: expenseDetails.projectId,
					expenseType: expenseDetails?.projectId ? 'shoot' : 'workspace',
					expenseDetails: _.cloneDeep(expenseDetails),
					editExpenseDetails: { ...expenseDetails },
					userId: decoded.user_id,
					tenantUsersList,
					tenantUsersListOptions,
					isExpensesLoading: false,
				});
			}
		} else {
			this.setState({
				isExpensesLoading: false,
				userId: decoded.user_id,
				tenantUsersList,
				tenantUsersListOptions,
			});
		}

		if (_.has(this.props, 'isFinanceSection') && this.props.isFinanceSection) {
			const getProjectVariable = {
				projectId: _.has(this.props.params, 'projectID')
					? this.props.params.projectID
					: this.props.projectId,
				workspaceId: this.props.params.workspaceID,
			};
			let tempProject = false;
			if (getProjectVariable.projectId) {
				tempProject = await this.getSingleProject(getSingleProject, getProjectVariable);
			}
			if (tempProject) {
				let tempObj = [
					...this.state.projectNameOptions,
					{ value: tempProject.id, label: tempProject.title },
				];
				this.setState({ projectNameOptions: tempObj }, async () => {
					const getProjectsVeriables = {
						filters: {
							page: this.state.page,
							limit: this.state.limit,
						},
						workspaceIds: [this.props.params.workspaceID],
					};
					await this.getProjectNameList(getProjectList, getProjectsVeriables);
				});
			} else {
				const getProjectsVeriables = {
					filters: {
						page: this.state.page,
						limit: this.state.limit,
					},
					workspaceIds: [this.props.params.workspaceID],
				};
				await this.getProjectNameList(getProjectList, getProjectsVeriables);
			}
		}

		if (_.has(this.props.params, 'projectID') || this.props.projectId) {
			const getEventsVariables = {
				filters: {
					projectId: _.has(this.props.params, 'projectID')
						? this.props.params.projectID
						: this.props.projectId,
					page: this.state.eventPage,
					limit: this.state.eventLimit,
					wsTenantIds: [this.props.tenantId],
				},
			};
			await this.getProjectNameList(getEventsList, getEventsVariables, 'expense');
			if (this.props.activeExpenseID === null && _.has(this.props.params, 'shootID')) {
				this.handleShootChange(this.props.params.shootID);
			}
			this.setState({ isProjectsLoading: false });
		} else {
			this.setState({
				isEventsLoading: false,
			});
		}

		if (document.getElementById('details')) {
			document.getElementById('details').scrollIntoView();
		}
		document.addEventListener('mousedown', this.handleClickOutside);
	};

	componentWillUnmount() {
		if (this.timer) {
			clearInterval(this.timer);
		}
		document.removeEventListener('mousedown', this.handleClickOutside);
	}
	handleClickOutside = (event) => {
		if (this.dropdownref.current && !this.dropdownref.current.contains(event.target)) {
			this.setState({
				showDropDown: false,
			});
		}
	};
	formatCurrency = (type, number) => {
		switch (type) {
			case 'inr':
				return new Intl.NumberFormat('en-IN', {
					maximumFractionDigits: 0,
					minimumFractionDigits: 0,
				}).format(number);
			case 'usd':
				return new Intl.NumberFormat('en-US', {
					maximumFractionDigits: 0,
					minimumFractionDigits: 0,
				}).format(number);
			default:
				return number;
		}
	};

	addNote = async (e, id = null) => {
		if (this.props.activeExpenseID !== null) {
			let response = false;
			let json = {
				addExpenseNoteId: id,
				noteInput: {
					message: e.target.value,
				},
				workspaceId: this.props.params.workspaceID,
				projectId: this.props.params.projectID,
			};

			response = await this.addNewProjectNote(addExpenseNote, json, 'expense');
			if (response !== false) {
				let editExpenseDetails = this.state.editExpenseDetails;
				let expensesDetails = this.state.expensesDetails;
				let inx = -1;
				inx = _.findIndex(expensesDetails, { id: id });
				if (inx !== -1) {
					expensesDetails[inx].notes = response;
				}
				editExpenseDetails.notes = response;

				this.setState({
					editExpenseDetails,
					expensesDetails,
				});
			}
		} else {
			let arr = this.state.newAddedNote;
			arr.push({ message: e.target.value });
			this.setState({
				newAddedNote: arr,
			});
		}
	};
	handleAddNote = (e, key) => {
		let arr = [...this.state.newAddedNote];
		arr[key] = { ...arr[key], message: e.target.value };
		this.setState({
			newAddedNote: arr,
		});
	};
	deleteNewNote = (e, key) => {
		let arr = [...this.state.newAddedNote];
		arr.splice(key, 1);
		this.setState({
			newAddedNote: arr,
		});
	};
	handleEditNote = (e, key) => {
		let arr = this.state.editExpenseDetails.notes;
		arr[key] = { ...arr[key], message: e.target.value };
		delete arr[key]['__typename'];
		this.setState({
			editExpenseDetails: {
				...this.state.editExpenseDetails,
				notes: arr,
			},
		});
	};
	deleteEditNote = async (e, key, id = null, note = null) => {
		let response = false;
		let json = {
			deleteExpenseNoteId: id,
			noteId: note._id,
			workspaceId: this.props.params.workspaceID,
			projectId: this.props.params.projectID,
		};
		response = await this.deleteProjectNote(deleteExpenseNote, json, 'expense');
		if (response !== false) {
			response = response.deleteExpenseNote.notes;
			let editExpenseDetails = this.state.editExpenseDetails;
			let expensesDetails = this.state.expensesDetails;
			let inx = -1;
			inx = _.findIndex(expensesDetails, { id: id });
			if (inx !== -1) {
				expensesDetails[inx].notes = response;
			}
			editExpenseDetails.notes = response;

			this.setState({
				editExpenseDetails,
				expensesDetails,
			});
		}
	};

	handleEventChange = async (e, name) => {
		let value;

		if (name === 'billDate' || name === 'travelDate') {
			if (e) {
				value = parseInt(moment(e).format('yyyyMMDD'));
			} else {
				value = parseInt(moment().format('YYYYMMDD'));
			}
		} else if (
			name === 'billTo' ||
			name === 'type' ||
			name === 'spentBy' ||
			name === 'bookedVia' ||
			name === 'status'
		) {
			value = e.value;
		} else {
			if (
				name === 'amount' ||
				name === 'ticketPrice' ||
				name === 'refundAmount' ||
				name === 'numberOfTravellers'
			) {
				value = e;
			} else {
				value = e.target.value;
			}
		}

		if (name === 'amount') {
			if (value == 0 || isNaN(value)) {
				this.setState({
					editExpenseAmountError: true,
				});
			} else {
				this.setState({
					editExpenseAmountError: false,
				});
			}
		}

		if (name === 'numberOfTravellers' || name === 'ticketPrice') {
			if (value == 0 || isNaN(value)) {
				this.setState({
					[`${name}Error`]: true,
					[`${name}ErrorMessage`]: 'Should be greater than 0',
				});
			} else {
				this.setState({
					[`${name}Error`]: false,
					[`${name}ErrorMessage`]: '',
				});
			}
		}

		if (name === 'bookingID' || name === 'travelFrom' || name === 'travelTo') {
			let error = `${name}Error`;
			let errorMessage = `${name}ErrorMessage`;
			if (value === '') {
				this.setState({
					[error]: true,
					[errorMessage]: 'Required',
				});
			} else {
				this.setState({
					[error]: false,
					[errorMessage]: '',
				});
			}
		}

		if (this.props.activeExpenseID == null) {
			this.setState(
				{
					[name]: value,
				},
				() => {
					if (name === 'ticketPrice') {
						if (this.state.ticketPrice == 0 || isNaN(this.state.ticketPrice)) {
							this.setState({
								lossAmount: 0,
							});
						} else {
							this.setState({
								lossAmount:
									parseInt(this.state.ticketPrice) -
									parseInt(this.state.refundAmount),
							});
						}
					}
					if (name === 'refundAmount') {
						if (isNaN(value)) {
							this.setState({
								lossAmount: 0,
							});
						} else {
							this.setState({
								lossAmount:
									parseInt(this.state.ticketPrice) -
									parseInt(this.state.refundAmount),
							});
						}
					}
				},
			);
		} else {
			if (
				name === 'numberOfTravellers' ||
				name === 'refundAmount' ||
				name === 'status' ||
				name === 'bookingID' ||
				name === 'bookedVia' ||
				name === 'travelDate' ||
				name === 'travelFrom' ||
				name === 'travelTo' ||
				name === 'ticketPrice' ||
				name === 'metaNotes' ||
				name === 'lossAmount'
			) {
				let editExpenseDetails = _.cloneDeep(this.state.editExpenseDetails);
				this.setState(
					{
						editExpenseDetails: {
							...editExpenseDetails,
							metaData: {
								...editExpenseDetails.metaData,
								[name === 'travelFrom'
									? 'from'
									: name === 'travelTo'
									? 'to'
									: name === 'metaNotes'
									? 'notes'
									: name]: value,
							},
						},
					},
					() => {
						if (name === 'status') {
							let editExpenseDetails = _.cloneDeep(this.state.editExpenseDetails);
							editExpenseDetails = {
								...editExpenseDetails,
								metaData: {
									...editExpenseDetails.metaData,
									lossAmount: editExpenseDetails.metaData.lossAmount
										? editExpenseDetails.metaData.lossAmount
										: editExpenseDetails.metaData.ticketPrice,
									refundAmount: editExpenseDetails.metaData.refundAmount
										? editExpenseDetails.metaData.refundAmount
										: 0,
								},
							};
							this.setState({
								editExpenseDetails,
							});
						}
						if (name === 'ticketPrice') {
							if (
								this.state.editExpenseDetails.metaData.ticketPrice == 0 ||
								isNaN(this.state.editExpenseDetails.metaData.ticketPrice)
							) {
								let editExpenseDetails = _.cloneDeep(this.state.editExpenseDetails);
								editExpenseDetails = {
									...editExpenseDetails,
									metaData: {
										...editExpenseDetails.metaData,
										lossAmount: 0,
									},
								};
								this.setState({
									editExpenseDetails,
								});
							} else {
								let editExpenseDetails = _.cloneDeep(this.state.editExpenseDetails);
								editExpenseDetails = {
									...editExpenseDetails,
									metaData: {
										...editExpenseDetails.metaData,
										lossAmount:
											parseInt(editExpenseDetails.metaData.ticketPrice) -
											parseInt(editExpenseDetails.metaData.refundAmount),
									},
								};
								this.setState({
									editExpenseDetails,
								});
							}
						}
						if (name === 'refundAmount') {
							if (isNaN(value)) {
								let editExpenseDetails = _.cloneDeep(this.state.editExpenseDetails);
								editExpenseDetails = {
									...editExpenseDetails,
									metaData: {
										...editExpenseDetails.metaData,
										lossAmount: 0,
									},
								};
								this.setState({
									editExpenseDetails,
								});
							} else {
								let editExpenseDetails = _.cloneDeep(this.state.editExpenseDetails);
								editExpenseDetails = {
									...editExpenseDetails,
									metaData: {
										...editExpenseDetails.metaData,
										lossAmount:
											parseInt(editExpenseDetails.metaData.ticketPrice) -
											parseInt(editExpenseDetails.metaData.refundAmount),
									},
								};
								this.setState({
									editExpenseDetails,
								});
							}
						}
					},
				);
			} else {
				this.setState({
					editExpenseDetails: {
						...this.state.editExpenseDetails,
						[name]: value,
					},
				});
			}
		}
	};
	handleSaveExpense = (e) => {
		let json;

		let projectId = _.has(this.props.params.projectID, 'projectID')
			? this.props.params.projectID
			: this.state.projectId;
		let updateExpenseFromVendorId = this.props.activeExpenseID;
		let expenseInput = _.cloneDeep(this.state.editExpenseDetails);

		expenseInput.files = _.map(expenseInput.files, (item, index) => {
			delete item['__typename'];
			delete item['src'];
			delete item['uploadSource'];
			return item;
		});

		delete expenseInput['id'];
		delete expenseInput['__typename'];
		delete expenseInput['notes'];
		delete expenseInput['projectId'];
		delete expenseInput['eventId'];
		delete expenseInput['files'];

		expenseInput['amount'] = parseInt(expenseInput['amount']);

		if (
			this.state.editExpenseDetails.spentBy === '' ||
			this.state.editExpenseDetails.spentBy === null
		) {
			delete expenseInput['spentBy'];
			//expenseInput['spentBy'] = this.state.spentBy;
		} else {
			expenseInput['spentBy'] = this.state.editExpenseDetails.spentBy;
		}
		if (
			this.state.editExpenseDetails.description === '' ||
			this.state.editExpenseDetails.description === null
		) {
			delete expenseInput['description'];
		}
		expenseInput['currency'] = this.state.currency;
		if (this.state.eventId && this.state.expenseType === 'shoot') {
			expenseInput['eventId'] = this.state.eventId;
		}

		if (
			this.state.editExpenseDetails.type === 'accomodation' ||
			this.state.editExpenseDetails.type === 'travelBus' ||
			this.state.editExpenseDetails.type === 'travelFlight'
		) {
		} else {
			expenseInput['metaData'] = null;
		}

		json = {
			projectId,
			updateExpenseFromVendorId,
			expenseInput,
			workspaceId: this.props.params.workspaceID,
		};

		if (this.state.expenseType === 'workspace') {
			delete json['projectId'];
		}

		if (
			parseInt(this.state.editExpenseDetails.amount) == 0 ||
			isNaN(parseInt(this.state.editExpenseDetails.amount))
		) {
			this.setState({
				editExpenseAmountError: true,
				disabledBtn: false,
			});
		} else {
			this.putExpense(saveExpense, json, getExpense, 'update', 'vendors');
		}
	};
	handleBlurEditNote = async (e, key, note, id, subType) => {
		let response = false;
		let json = {
			updateExpenseNoteId: id,
			noteId: note._id,
			noteInput: {
				message: note.message,
			},
			projectId: this.props.params.projectID,
			workspaceId: this.props.params.workspaceID,
		};
		if (this.state.projectId !== null) {
		}
		response = await this.updateProjectNote(updateExpenseNote, json, 'expense');
		if (response !== false) {
			let editExpenseDetails = this.state.editExpenseDetails;
			let expensesDetails = this.state.expensesDetails;
			let inx = -1;

			inx = _.findIndex(expensesDetails, { id: id });
			if (inx !== -1) {
				expensesDetails[inx].notes = response;
			}
			editExpenseDetails.notes = response;

			this.setState({
				editExpenseDetails,
				expensesDetails,
			});
		}
	};
	handleAddExpense = (e) => {
		let json;

		let projectId = _.has(this.props.params, 'projectID')
			? this.props.params.projectID
			: this.state.projectId;
		let expenseInput = {
			amount: parseInt(this.state.amount),
			billTo: this.state.billTo == null ? 'company' : this.state.billTo,
			billDate: this.state.billDate,
			type: this.state.type == null ? 'food' : this.state.type,
		};
		if (this.state.spentBy) {
			expenseInput['spentBy'] = this.state.spentBy;
		}
		if (_.size(this.state.files) > 0) {
			let tempFiles = _.map(this.state.files, (file, index) => {
				delete file['src'];
				return file;
			});
			expenseInput['files'] = tempFiles;
		}
		if (this.state.description) {
			expenseInput['description'] = this.state.description;
		}
		if (_.size(this.state.newAddedNote) > 0) {
			expenseInput['notes'] = this.state.newAddedNote;
		}
		if (this.state.eventId && this.state.expenseType === 'shoot') {
			expenseInput['eventId'] = this.state.eventId;
		}

		if (this.state.expenseType === 'workspace') {
			expenseInput['billTo'] = 'company';
		}
		expenseInput['currency'] = this.state.currency;

		if (
			this.state.type === 'accomodation' ||
			this.state.type === 'travelBus' ||
			this.state.type === 'travelFlight'
		) {
			expenseInput['metaData'] = {};
			expenseInput['metaData']['bookingID'] = this.state.bookingID;
			expenseInput['metaData']['numberOfTravellers'] = this.state.numberOfTravellers;
			expenseInput['metaData']['bookedVia'] = this.state.bookedVia;
			expenseInput['metaData']['travelDate'] = this.state.travelDate;
			expenseInput['metaData']['from'] = this.state.travelFrom;
			expenseInput['metaData']['to'] = this.state.travelTo;
			expenseInput['metaData']['status'] = this.state.status;
			expenseInput['metaData']['ticketPrice'] = parseInt(this.state.ticketPrice);
			if (this.state.metaNotes) {
				expenseInput['metaData']['notes'] = this.state.metaNotes;
			}
			if (this.state.status === 'cancelled') {
				expenseInput['metaData']['refundAmount'] = parseInt(this.state.refundAmount);
				expenseInput['metaData']['lossAmount'] = parseInt(this.state.lossAmount);
			}
		}

		json = {
			expenseInput,
			workspaceId: this.props.params.workspaceID,
		};

		if (this.state.expenseType === 'shoot') {
			json.projectId = projectId;
		}

		if (this.state.amount == 0 || isNaN(this.state.amount)) {
			this.setState({
				editExpenseAmountError: true,
				disabledBtn: false,
			});
		} else {
			this.putExpense(addExpense, json, getExpense, 'add', 'vendors');
		}
	};
	toggleDropDown = (e) => {
		this.setState({
			showDropDown: !this.state.showDropDown,
		});
	};
	handleDelete = (e) => {
		let json;
		let projectId = _.has(this.props.params, 'projectID')
			? this.props.params.projectID
			: this.state.projectId;
		let deleteExpenseFromVendorId = this.props.activeExpenseID;
		json = {
			deleteExpenseFromVendorId,
			workspaceId: this.props.params.workspaceID,
		};

		if (this.state.expenseType === 'shoot') {
			json.projectId = projectId;
		}

		this.putExpense(deleteExpense, json, getExpense, 'delete', 'vendors');
	};

	checkUploadStatus = () => {
		let fileVariables = {
			uploadBatchId: this.state.uploadBatchId,
			branchId: 'VEHYD',
		};
		let failCounter = 0;
		let complete = false;
		let completedFiles = [];
		let processing = false;
		let counter = 0;
		this.timer = setInterval(async () => {
			counter += 1;
			if (processing === false) {
				processing = true;
				let file = await this.getFileInfo(getFileUploadStatus, fileVariables, 'branch');
				if (file !== false) {
					failCounter = 0;
					if (file.uploadedCount > 0 && complete === false) {
						let uploadedCount = file.uploadedCount;
						if (
							file.uploadedCount + this.state.totalSignedUrlErrorCount ===
							_.size(this.state.fileUpload)
						) {
							complete = true;
						}
						let isAPICalled = false;
						let filesUploaded = file.filesUploaded;
						for (let file of filesUploaded) {
							let found = undefined;
							found = _.find(completedFiles, { _id: file._id });

							if (found) {
								continue;
							}
							completedFiles.push(file);

							if (this.props.activeExpenseID === null) {
								let files = this.state.files;
								let fileUpload = this.state.fileUpload;
								delete file['__typename'];

								let foundIndex = -1;
								foundIndex = _.findIndex(fileUpload, { id: file._id });
								if (foundIndex !== -1) {
									fileUpload[foundIndex].isUploading = false;
									fileUpload[foundIndex].isSuccess = true;
									file.fileType = fileUpload[foundIndex].type2;
									file.originalFileSizeInMb =
										fileUpload[foundIndex].originalFileSizeInMb;
								}
								let getSignedUrlVariables = {
									fileId: file._id,
									branchId: 'VEHYD',
									workspaceId: this.props.params.workspaceID,
								};

								let res = await this.getFileSignedUrl(
									getFileSignedUrl,
									getSignedUrlVariables,
									null,
									'vendors',
								);

								if (res !== false) {
									file.src = res;
								} else {
									file.src = null;
								}

								files.push(file);

								this.setState({ files, fileUpload }, () => {
									if (
										_.size(files) + this.state.totalSignedUrlErrorCount ===
										_.size(this.state.fileUpload)
									) {
										this.setState({
											isUploadComplete: true,
											isFileLoading: false,
											fileUpload: [],
											readyToUploadFiles: [],
											isReadyFilesLoaded: false,
										});

										this.handleAddExpense();

										clearInterval(this.timer);
									}
								});
							} else {
								let editExpenseDetails = this.state.editExpenseDetails;
								let fileUpload = this.state.fileUpload;
								let totalSignedUrlErrorCount = this.state.totalSignedUrlErrorCount;
								delete file['__typename'];

								let foundIndex = -1;
								foundIndex = _.findIndex(fileUpload, { id: file._id });
								if (foundIndex !== -1) {
									fileUpload[foundIndex].isUploading = false;
									fileUpload[foundIndex].isSuccess = true;
									file.fileType = fileUpload[foundIndex].type2;
									file.originalFileSizeInMb =
										fileUpload[foundIndex].originalFileSizeInMb;
								}
								if (editExpenseDetails.files === null) {
									editExpenseDetails.files = [];
								}

								let attachFileVariables = {
									attachFileToExpenseId: this.props.activeExpenseID,
									workspaceId: this.props.params.workspaceID,
									projectId: _.has(this.props.params, 'projectID')
										? this.props.params.projectID
										: this.state.projectId,
									files: [{ ...file }],
								};

								let res2 = false;
								res2 = await this.attachFile(
									attachFileToExpense,
									attachFileVariables,
								);

								if (res2 === false) {
									fileUpload[foundIndex].isSuccess = false;
									totalSignedUrlErrorCount += 1;
								}

								let getSignedUrlVariables = {
									fileId: file._id,
									branchId: 'VEHYD',
									workspaceId: this.props.params.workspaceID,
								};

								let res = await this.getFileSignedUrl(
									getFileSignedUrl,
									getSignedUrlVariables,
									null,
									'vendors',
								);

								if (res !== false) {
									file.src = res;
								} else {
									file.src = null;
								}

								editExpenseDetails.files.push(file);
								this.setState(
									{ editExpenseDetails, fileUpload, totalSignedUrlErrorCount },
									() => {
										if (
											_.size(completedFiles) +
												this.state.totalSignedUrlErrorCount ===
												_.size(this.state.fileUpload) &&
											isAPICalled === false
										) {
											isAPICalled = true;
											this.setState({
												isUploadComplete: true,
												isFileLoading: false,
												fileUpload: [],
												readyToUploadFiles: [],
												isReadyFilesLoaded: false,
											});
											this.handleSaveExpense();

											clearInterval(this.timer);
										}
									},
								);
							}
						}
					}
					processing = false;
				} else {
					failCounter += 1;
					if (failCounter > 9) {
						this.uploadFailedCompute();
						clearInterval(this.timer);
					}
					processing = false;
				}
			}
		}, 1000);
	};

	uploadFailedCompute = () => {
		let fileUpload = this.state.fileUpload;

		fileUpload = _.map(fileUpload, (item, index) => {
			item.isUploading = false;
			if (item.isSuccess === true) {
				return item;
			} else {
				item.isSuccess = false;
			}
			return item;
		});

		this.setState({
			isFileLoading: false,
			fileUpload,
			isUploadComplete: true,
		});
	};

	uploadFile = async (mutation, variables, files, index) => {
		let usertoken = localStorage.getItem('usertoken');
		let vendorID = this.props.params.vendorID;
		var response;
		let fileUpload = this.state.fileUpload;
		try {
			response = await service.mutation(mutation, variables, vendorID, usertoken, 'vendors');
		} catch (e) {
			fileUpload[index].isSignedUrlError = true;
		}
		if (response[0] === true) {
			fileUpload[index].signedUrl = response[1].data.uploadVendorFile['signedUrl'];
			fileUpload[index].id = response[1].data.uploadVendorFile['fileId'];
		} else {
			fileUpload[index].isSignedUrlError = true;
		}
		this.setState({ fileUpload }, async () => {
			let isComplete = _.every(fileUpload, (fi, inx) => {
				if (fi.signedUrl !== null || fi.isSignedUrlError == true) {
					return true;
				} else {
					return false;
				}
			});
			if (isComplete) {
				let totalSignedUrlErrorCount = _.size(
					_.filter(fileUpload, { isSignedUrlError: true }),
				);
				this.setState({ totalSignedUrlErrorCount, uploadFileErrorCount: 0 }, async () => {
					let isFirst = true;
					let inx = 0;
					for (let f of files) {
						if (fileUpload[inx].isSignedUrlError === true) {
							return;
						}
						if (isFirst === true) {
							isFirst = false;
							this.checkUploadStatus();
						}
						let res = false;
						res = await this.axiosPutFileCallToS3Bucket(f, fileUpload[inx].signedUrl);
						if (res === true) {
						} else {
							this.setState({
								uploadFileErrorCount: this.state.uploadFileErrorCount + 1,
							});
						}
						inx += 1;
					}
				});
			}
		});
	};

	readUploadingFile = (file, index, size) => {
		let reader = new FileReader();

		reader.onload = (e) => {
			let fileUpload = this.state.fileUpload;
			fileUpload[index].src = reader.result;
			this.setState({ fileUpload });
			if (index + 1 === size) {
				this.setState({
					//isFileLoading: true,
					isReadyFilesLoaded: true,
					isUploadComplete: false,
				});
			}
		};
		reader.readAsDataURL(file);
	};

	onDrop = async (files) => {
		let fileUpload = this.state.fileUpload;
		let initialFileUploadSize = _.size(this.state.fileUpload);
		let uploadBatchId = this.state.uploadBatchId;
		let readyToUploadFiles = this.state.readyToUploadFiles;
		let inx = initialFileUploadSize;
		for (let f of files) {
			readyToUploadFiles.push(f);
			fileUpload.push({
				signedUrl: null,
				id: null,
				type: '',
				type2: '',
				src: null,
				isSuccess: false,
				isUploading: true,
				isSignedUrlError: false,
				originalFileName: f.name,
				originalFileSizeInMb: f.size,
				originalDateTime: moment(f['originalDate']).unix(),
				uploadBatchId: this.state.uploadBatchId,
			});
			if (f.type === 'application/pdf') {
				fileUpload[inx].type = 'pdf';
				fileUpload[inx].type2 = 'pdf';
			} else if (f.type === 'image/jpeg' || f.type === 'image/png') {
				fileUpload[inx].type = 'image';
				if (f.type === 'image/jpeg') {
					fileUpload[inx].type2 = 'jpeg';
				} else if (f.type === 'image/png') {
					fileUpload[inx].type2 = 'png';
				}
			}
			inx += 1;
		}
		inx = 0;
		this.setState(
			{ fileUpload, uploadBatchId, uploadFileErrorCount: 0, readyToUploadFiles },
			() => {
				for (let f of files) {
					this.readUploadingFile(
						f,
						_.size(fileUpload) - _.size(files) + inx,
						_.size(fileUpload),
					);
					inx += 1;
				}
			},
		);
	};

	startUploadingFiles = async () => {
		let inx = 0;
		for (let f of this.state.fileUpload) {
			let uploadVariables = {
				uploadInput: {
					originalFileName: f.originalFileName,
					originalDateTime: f.originalDateTime,
					uploadBatchId: f.uploadBatchId,
				},
				branchId: 'VEHYD',
			};

			/* if (this.state.expenseType === 'shoot' || !_.has(this.props, 'isFinanceSection')) {
				uploadVariables = {
					...uploadVariables,
					projectId: _.has(this.props.params, 'projectID')
						? this.props.params.projectID
						: this.state.projectId,
				};
			} */
			let res = await this.uploadFile(
				uploadProjectFile,
				uploadVariables,
				this.state.readyToUploadFiles,
				inx,
			);

			inx += 1;
		}
	};

	handleDeleteUploadReadyFile = async (index) => {
		let readyToUploadFiles = this.state.readyToUploadFiles;
		let fileUpload = this.state.fileUpload;
		fileUpload.splice(index, 1);
		readyToUploadFiles.splice(index, 1);
		this.setState({ readyToUploadFiles, fileUpload });
	};

	fetchMoreOptions = async () => {
		if (this.state.hasNextPage === true) {
			this.setState({ page: this.state.page + 1 }, async () => {
				const getProjectsVariables = {
					filters: {
						page: this.state.page,
						limit: this.state.limit,
					},
					workspaceIds: [this.props.params.workspaceID],
				};
				await this.getProjectNameList(getProjectList, getProjectsVariables);
			});
		}
	};

	handleDeleteFile = async (index) => {
		if (this.props.activeExpenseID === null) {
			let files = this.state.files;
			files.splice(index, 1);
			this.setState({ files });
		} else {
			let res = false;
			let deleteFileVariables = {
				fileId: this.state.editExpenseDetails.files[index]._id,
			};

			if (this.state.editExpenseDetails.files[index].uploadSource === 'vendor') {
				deleteFileVariables['detachFileFromVendorExpenseId'] = this.props.activeExpenseID;
				deleteFileVariables['projectId'] = _.has(this.props.params, 'projectID')
					? this.props.params.projectID
					: this.state.projectId;
				deleteFileVariables['workspaceId'] = this.props.params.workspaceID;
			} else {
				deleteFileVariables['detachFileFromExpenseId'] = this.props.activeExpenseID;
				if (_.has(this.props.params, 'projectID') || this.state.projectId) {
					deleteFileVariables.projectId = _.has(this.props.params, 'projectID')
						? this.props.params.projectID
						: this.state.projectId;
				}
			}

			res = await this.deleteFile(
				this.state.editExpenseDetails.files[index].uploadSource === 'vendor'
					? detachFileFromExpense
					: detachProjectFileFromExpense,
				deleteFileVariables,
				this.state.editExpenseDetails.files[index].uploadSource === 'vendor'
					? null
					: 'projects',
			);

			if (res) {
				let files = this.state.editExpenseDetails.files;
				files.splice(index, 1);
				this.setState({
					editExpenseDetails: { ...this.state.editExpenseDetails, files },
				});
				this.props.expenseDetailsUpdated();
			}
		}
	};

	isDisabled = () => {
		if (this.props.activeExpenseID === null) {
			if (
				this.state.amount === null ||
				this.state.amount === '' ||
				this.state.amount === 0 ||
				(this.state.expenseType === 'shoot' && this.state.projectId === null) ||
				(this.state.expenseType === 'shoot' && this.state.eventId === null) ||
				this.state.editExpenseAmountError === true ||
				((this.state.type === 'accomodation' ||
					this.state.type === 'travelBus' ||
					this.state.type === 'travelFlight') &&
					(this.state.bookingIDError === true ||
						this.state.bookingID === null ||
						this.state.bookingID === '' ||
						parseInt(this.state.ticketPrice === 0) ||
						isNaN(parseInt(this.state.ticketPrice)) ||
						this.state.ticketPriceError ||
						this.state.travelFrom === '' ||
						this.state.travelFromError ||
						this.state.travelTo === '' ||
						this.state.travelToError ||
						this.state.status === '' ||
						this.state.status === null ||
						(this.state.status === 'cancelled' &&
							isNaN(parseInt(this.state.refundAmount))) ||
						this.state.refundAmountError === true ||
						isNaN(parseInt(this.state.numberOfTravellers)) ||
						this.state.numberOfTravellers === '' ||
						this.state.numberOfTravellersError === true ||
						(this.state.status === 'cancelled' &&
							isNaN(parseInt(this.state.lossAmount)))))
			) {
				return true;
			} else {
				return false;
			}
		} else if (this.props.activeExpenseID !== null) {
			if (
				this.state.editExpenseAmountError === true ||
				this.state.editExpenseDetails.amount === null ||
				this.state.editExpenseDetails.amount === '' ||
				this.state.editExpenseDetails.amount === 0 ||
				(this.state.expenseType === 'shoot' && this.state.eventId === null) ||
				(this.state.expenseDetails.eventId === this.state.eventId &&
					this.state.expenseDetails.projectId === this.state.projectId &&
					this.state.expenseDetails.type === this.state.editExpenseDetails.type &&
					this.state.expenseDetails.billTo === this.state.editExpenseDetails.billTo &&
					this.state.expenseDetails.amount === this.state.editExpenseDetails.amount &&
					this.state.expenseDetails.billDate === this.state.editExpenseDetails.billDate &&
					this.state.expenseDetails.description ===
						this.state.editExpenseDetails.description &&
					this.state.expenseDetails.spentBy === this.state.editExpenseDetails.spentBy &&
					_.isEqual(
						this.state.editExpenseDetails.files,
						this.state.expenseDetails.files,
					) &&
					_.size(this.state.readyToUploadFiles) === 0 &&
					(this.state.editExpenseDetails.type === 'accomodation' ||
					this.state.editExpenseDetails.type === 'travelBus' ||
					this.state.editExpenseDetails.type === 'travelFlight'
						? this.state.expenseDetails.metaData.bookingID ===
								this.state.editExpenseDetails.metaData.bookingID &&
						  this.state.expenseDetails.metaData.ticketPrice ===
								this.state.editExpenseDetails.metaData.ticketPrice &&
						  this.state.expenseDetails.metaData.from ===
								this.state.editExpenseDetails.metaData.from &&
						  this.state.expenseDetails.metaData.to ===
								this.state.editExpenseDetails.metaData.to &&
						  this.state.expenseDetails.metaData.numberOfTravellers ===
								this.state.editExpenseDetails.metaData.numberOfTravellers &&
						  this.state.expenseDetails.metaData.bookedVia ===
								this.state.editExpenseDetails.metaData.bookedVia &&
						  this.state.expenseDetails.metaData.travelDate ===
								this.state.editExpenseDetails.metaData.travelDate &&
						  this.state.expenseDetails.metaData.refundAmount ===
								this.state.editExpenseDetails.metaData.refundAmount &&
						  this.state.expenseDetails.metaData.lossAmount ===
								this.state.editExpenseDetails.metaData.lossAmount &&
						  this.state.expenseDetails.metaData.notes ===
								this.state.editExpenseDetails.metaData.notes &&
						  this.state.expenseDetails.metaData.status ===
								this.state.editExpenseDetails.metaData.status
						: true)) ||
				((this.state.editExpenseDetails.type === 'accomodation' ||
					this.state.editExpenseDetails.type === 'travelBus' ||
					this.state.editExpenseDetails.type === 'travelFlight') &&
					(this.state.editExpenseDetails.metaData.bookingIDError === true ||
						this.state.editExpenseDetails.metaData.bookingID === null ||
						this.state.editExpenseDetails.metaData.bookingID === '' ||
						parseInt(this.state.editExpenseDetails.metaData.ticketPrice) === 0 ||
						isNaN(parseInt(this.state.editExpenseDetails.metaData.ticketPrice)) ||
						this.state.ticketPriceError === true ||
						this.state.editExpenseDetails.metaData.from === '' ||
						this.state.travelFromError === true ||
						this.state.editExpenseDetails.metaData.to === '' ||
						this.state.travelToError === true ||
						this.state.editExpenseDetails.metaData.status === '' ||
						this.state.editExpenseDetails.metaData.status === null ||
						(this.state.editExpenseDetails.metaData.status === 'cancelled' &&
							isNaN(parseInt(this.state.editExpenseDetails.metaData.refundAmount))) ||
						this.state.refundAmountError === true ||
						isNaN(
							parseInt(this.state.editExpenseDetails.metaData.numberOfTravellers),
						) ||
						this.state.editExpenseDetails.metaData.numberOfTravellers === '' ||
						this.state.editExpenseDetails.metaData.numberOfTravellersError === true ||
						(this.state.editExpenseDetails.metaData.status === 'cancelled' &&
							isNaN(parseInt(this.state.editExpenseDetails.metaData.lossAmount)))))
			) {
				return true;
			} else {
				return false;
			}
		}
	};

	handleCloseModal = () => {
		if (this.props.activeExpenseID === null) {
			this.setState({ showDiscardModal: true });
		} else if (this.props.activeExpenseID !== null) {
			if (
				this.state.expenseDetails.eventId === this.state.eventId &&
				this.state.expenseDetails.projectId === this.state.projectId &&
				this.state.expenseDetails.type === this.state.editExpenseDetails.type &&
				this.state.expenseDetails.billTo === this.state.editExpenseDetails.billTo &&
				this.state.expenseDetails.amount === this.state.editExpenseDetails.amount &&
				this.state.expenseDetails.billDate === this.state.editExpenseDetails.billDate &&
				this.state.expenseDetails.description ===
					this.state.editExpenseDetails.description &&
				this.state.expenseDetails.spentBy === this.state.editExpenseDetails.spentBy &&
				_.isEqual(this.state.editExpenseDetails.files, this.state.expenseDetails.files) &&
				_.size(this.state.readyToUploadFiles) === 0
			) {
				this.props.handleClose();
			} else {
				this.setState({ showDiscardModal: true });
			}
		}
	};

	handleExpenseTypeChange = (e) => {
		this.setState({
			expenseType: e.value,
		});
	};

	handleAddEditExpense = () => {
		if (_.size(this.state.fileUpload) == 0) {
			if (this.props.activeExpenseID == null) {
				this.handleAddExpense();
			} else {
				this.handleSaveExpense();
			}
		} else {
			this.startUploadingFiles();
		}
	};

	handleProjectChange = (e) => {
		this.setState(
			{
				projectId: e.value,
				eventId: null,
				spentBy: null,
			},
			() => {
				if (this.state.projectId === null) {
					this.setState({
						eventNameOptions:
							this.props.activeExpenseID === null
								? [{ value: null, label: 'Select' }]
								: [],
					});
				} else {
					this.setState(
						{
							eventPage: 1,
							hasNextEventsPage: true,
							eventNameOptions:
								this.props.activeExpenseID === null
									? [{ value: null, label: 'Select' }]
									: [],
						},
						() => {
							const getEventsVariables = {
								filters: {
									projectId: _.has(this.props.params, 'projectID')
										? this.props.params.projectID
										: this.state.projectId,
									page: this.state.eventPage,
									limit: this.state.eventLimit,
									wsTenantIds: [this.props.tenantId],
								},
							};
							this.getProjectNameList(getEventsList, getEventsVariables, 'expense');
						},
					);
				}
			},
		);
	};

	handleShootChange = async (value) => {
		this.setState({ eventId: value }, async () => {
			if (this.state.eventId !== null) {
				let json = {
					projectId: _.has(this.props.params, 'projectID')
						? this.props.params.projectID
						: this.state.projectId,
					vendorEventId: this.state.eventId,
					workspaceId: this.props.params.workspaceID,
				};
				let res = await this.getSingleEvent(getEvent, json);

				if (res !== false) {
					let spentByOptions = [];

					_.forEach(res.crewNew, (user) => {
						let found = _.find(this.props.tenantUsersList, { id: user.userId });
						if (found !== undefined) {
							spentByOptions.push({
								value: found.id,
								label: found.firstName + ' ' + found.lastName,
							});
						}
					});

					this.setState({
						spentByOptions,
					});
				}
			} else {
				this.setState({
					spentByOptions: [{ value: null, label: 'Select' }],
					spentBy: null,
				});
			}
		});
	};

	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'right-add'}
			>
				{this.state.isExpensesLoading === true ||
				this.state.isProjectsLoading === true ||
				this.state.isEventsLoading ? (
					<LoadingBar />
				) : (
					<>
						<div className="project-add-edit-popup">
							<div className="project-add-edit-popup-header">
								<span className="header-title">
									{this.props.activeExpenseID == null
										? 'New Expense'
										: `₹ ${this.formatCurrency(
												'inr',
												this.state.editExpenseDetails.amount,
										  )}`}
								</span>
								{this.props.activeExpenseID !== null ? (
									<span
										className="header-more-icn"
										onClick={(e) => this.toggleDropDown(e)}
									>
										<MoreVerticalIcon />
									</span>
								) : null}
								{this.state.showDropDown === true ? (
									<div className="delete-action-dropdown">
										<div
											className="delete-action-item"
											ref={this.dropdownref}
											onClick={(e) =>
												this.setState({
													showDeleteConfirmationModal: true,
												})
											}
										>
											<span className="delete-icn">
												<DeleteIcon />
											</span>
											<span className="delete-text">Delete Expense</span>
										</div>
									</div>
								) : null}
							</div>
							<div className="project-add-edit-popup-subheader">
								<a
									href="#details"
									className={
										this.state.currentTab === 'details'
											? 'sub-header-title active'
											: 'sub-header-title'
									}
									onClick={() =>
										this.setState({
											currentTab: 'details',
										})
									}
								>
									DETAILS
								</a>
								<a
									href="#assignedto"
									className={
										this.state.currentTab === 'assignedTo'
											? 'sub-header-title active'
											: 'sub-header-title'
									}
									onClick={() =>
										this.setState({
											currentTab: 'assignedTo',
										})
									}
								>
									ATTACHMENTS
								</a>
								<a
									href="#notes"
									className={
										this.state.currentTab === 'notes'
											? 'sub-header-title active'
											: 'sub-header-title'
									}
									onClick={() =>
										this.setState({
											currentTab: 'notes',
										})
									}
								>
									NOTES
								</a>
								<a
									href="#bookingDetails"
									className={
										this.state.currentTab === 'bookingDetails'
											? 'sub-header-title active'
											: 'sub-header-title'
									}
									onClick={() =>
										this.setState({
											currentTab: 'bookingDetails',
										})
									}
								>
									BOOKING DETAILS
								</a>
							</div>
							<div className="project-add-edit-popup-body">
								<div className="project-add-edit-popup-body-item" id={'details'}>
									<div className="popup-body-title">EXPENSE DETAILS</div>
									{_.has(this.props, 'isFinanceSection') &&
									this.props.isFinanceSection ? (
										<div className="floating-select-container">
											<label>Type</label>
											<Select
												className={
													'cost-select-container zIndex6 w-100p' +
													(this.props.activeExpenseID !== null
														? ' read-only-select'
														: '')
												}
												classNamePrefix="cost-select"
												options={this.state.expenseTypeOptions}
												onChange={(e) => this.handleExpenseTypeChange(e)}
												defaultValue={
													this.state.editExpenseDetails.projectId === null
														? this.state.expenseTypeOptions[1]
														: _.find(this.state.expenseTypeOptions, {
																value: this.state.expenseType,
														  })
												}
												isSearchable={false}
												isDisabled={
													this.props.activeExpenseID !== null
														? true
														: false
												}
											/>
										</div>
									) : null}
									{_.has(this.props, 'isFinanceSection') &&
									this.props.isFinanceSection &&
									this.state.expenseType === 'workspace' ? null : (
										<>
											{_.has(this.props, 'isFinanceSection') &&
											this.props.isFinanceSection ? (
												<div className="floating-select-container">
													<label>
														Project
														<span className="required-input-new">
															*
														</span>
													</label>
													<Select
														className={
															'cost-select-container zIndex5 w-100p' +
															(this.props.activeExpenseID !== null
																? ' read-only-select'
																: '')
														}
														classNamePrefix="cost-select"
														options={this.state.projectNameOptions}
														onChange={(e) =>
															this.handleProjectChange(e)
														}
														defaultValue={
															this.props.activeExpenseID === null
																? this.state.projectId === null
																	? this.state
																			.projectNameOptions[0]
																	: _.find(
																			this.state
																				.projectNameOptions,
																			{
																				value: this.state
																					.projectId,
																			},
																	  )
																: this.state.editExpenseDetails
																		.projectId === null
																? this.state.projectNameOptions[0]
																: _.find(
																		this.state
																			.projectNameOptions,
																		{
																			value: this.state
																				.editExpenseDetails
																				.projectId,
																		},
																  )
														}
														onMenuScrollToBottom={(e) =>
															this.fetchMoreOptions()
														}
														isDisabled={
															this.props.activeExpenseID !== null
																? true
																: false
														}
														isSearchable={false}
													/>
												</div>
											) : (
												<InputHeader
													type="text"
													name="project"
													value={this.props.projectTitle}
													readOnly={true}
													onChange={(e) => {}}
													isInputError={false}
													label="Project"
												/>
											)}

											{!_.has(this.props.params, 'shootID') ? (
												<div className="floating-select-container">
													<label>
														Event
														<span className="required-input-new">
															*
														</span>
													</label>
													<Select
														className="cost-select-container zIndex4 w-100p"
														classNamePrefix="cost-select"
														options={this.state.eventNameOptions}
														onChange={(e) =>
															this.handleShootChange(e.value)
														}
														defaultValue={
															this.props.activeExpenseID === null
																? this.state.eventId === null
																	? this.state.eventNameOptions[0]
																	: _.find(
																			this.state
																				.eventNameOptions,
																			{
																				value: this.state
																					.eventId,
																			},
																	  )
																: this.state.editExpenseDetails
																		.eventId === null
																? this.state.eventNameOptions[0]
																: _.find(
																		this.state.eventNameOptions,
																		{
																			value: this.state
																				.editExpenseDetails
																				.eventId,
																		},
																  )
														}
														isSearchable={false}
													/>
												</div>
											) : (
												<InputHeader
													type="text"
													name="eventId"
													value={
														_.find(this.state.eventNameOptions, {
															value: this.props.params.shootID,
														})?.label
													}
													readOnly={true}
													onChange={(e) => {}}
													isInputError={false}
													label="Event"
												/>
											)}
											<div className="floating-select-container">
												<label>Billed to</label>
												<Select
													className="cost-select-container zIndex3 w-100p"
													classNamePrefix="cost-select"
													styles={this.colourStyles}
													options={this.state.billedToOptions}
													onChange={(e) =>
														this.handleEventChange(e, 'billTo')
													}
													defaultValue={
														this.props.activeExpenseID == null
															? this.state.billedToOptions[0]
															: this.state.editExpenseDetails.billTo
															? _.filter(this.state.billedToOptions, {
																	value: this.state
																		.editExpenseDetails.billTo,
															  })
															: this.state.billedToOptions[0]
													}
													isSearchable={false}
												/>
											</div>
										</>
									)}
									<div className="floating-select-container">
										<label>Category</label>
										<Select
											className="cost-select-container zIndex2 w-100p"
											classNamePrefix="cost-select"
											options={this.state.categoryOptions}
											onChange={(e) => this.handleEventChange(e, 'type')}
											defaultValue={
												this.props.activeExpenseID == null
													? this.state.categoryOptions[0]
													: this.state.editExpenseDetails.type
													? _.filter(this.state.categoryOptions, {
															value: this.state.editExpenseDetails
																.type,
													  })
													: this.state.categoryOptions[0]
											}
											isSearchable={false}
										/>
									</div>
									<InputHeader
										type="text"
										name="amount"
										isInputError={this.state.editExpenseAmountError}
										label="Amount"
										value={this.formatCurrency(
											'inr',
											this.props.activeExpenseID == null
												? this.state.amount
												: this.state.editExpenseDetails.amount,
										)}
										onChange={(e) =>
											this.handleEventChange(
												e.target.value === ''
													? 0
													: parseInt(e.target.value.replace(/,/g, '')),
												'amount',
											)
										}
										errorMessage={
											this.state.editExpenseAmountError ? 'required' : ''
										}
										required={true}
									/>
									<DatePicker
										selected={
											this.props.activeExpenseID == null
												? this.state.billDate == null
													? null
													: moment(
															this.state.billDate.toString(),
															'YYYYMMDD',
													  ).toDate()
												: this.state.editExpenseDetails.billDate &&
												  this.state.editExpenseDetails.billDate !== null
												? moment(
														this.state.editExpenseDetails.billDate.toString(),
														'YYYYMMDD',
												  ).toDate()
												: null
										}
										onChange={(e) => this.handleEventChange(e, 'billDate')}
										dateFormat="dd MMM yyyy"
										//placeholderText="dd / mm / yyyy"
										customInput={
											<CustomDateInput customLabel={'Expense Date'} />
										}
										wrapperClassName="w-100p"
										openToDate={new Date()}
									/>
									<div className="floating-select-container">
										<label>SpentBy</label>
										<Select
											className="cost-select-container zIndex1 w-100p"
											classNamePrefix="cost-select"
											options={this.state.spentByOptions}
											onChange={(e) => this.handleEventChange(e, 'spentBy')}
											defaultValue={
												this.props.activeExpenseID === null
													? this.state.spentBy === null
														? [{ value: null, label: 'Select' }]
														: _.find(this.state.spentByOptions, {
																value: this.state.spentBy,
														  })
													: this.state.editExpenseDetails.spentBy === null
													? [{ value: null, label: 'Select' }]
													: _.find(this.state.spentByOptions, {
															value: this.state.editExpenseDetails
																.spentBy,
													  })
											}
											isSearchable={false}
										/>
									</div>
									<InputHeader
										type="text"
										name="description"
										isInputError={false}
										label="Description"
										value={
											this.props.activeExpenseID == null
												? this.state.description
												: this.state.editExpenseDetails.description
										}
										onChange={(e) => this.handleEventChange(e, 'description')}
									/>
								</div>
								<div
									className="project-add-edit-popup-body-item gap-24px"
									id={'assignedto'}
								>
									<div className="popup-body-title">ATTACHMENTS</div>
									{this.props.activeExpenseID === null &&
									this.state.expenseType === 'shoot' &&
									this.state.projectId === null ? (
										<span className="attachments-condition-text">
											Please Choose Project to attach files.
										</span>
									) : (
										<Dropzone
											onDrop={this.onDrop}
											accept={'image/jpeg, image/png, application/pdf'}
											multiple={true}
											disabled={this.state.isFileLoading}
										>
											{({ getRootProps, getInputProps }) => (
												<div
													className="upload-border-container"
													{...getRootProps({})}
												>
													<span className="upload-icn">
														<AttachmentIcon />
													</span>
													<span className="upload-text">
														Upload files
														<input {...getInputProps()} />
													</span>
												</div>
											)}
										</Dropzone>
									)}
									<div className="uploaded-files-container">
										<>
											{_.map(
												this.props.activeExpenseID !== null
													? this.state.editExpenseDetails.files
													: this.state.files,
												(file, index) => {
													return (
														<div
															key={`sjdflksjdf2367567${index}`}
															className="uploaded-files-image-bg"
															style={
																file.fileType === 'jpeg' ||
																file.fileType === 'png'
																	? {
																			backgroundImage: `url(${file.src})`,
																	  }
																	: {}
															}
														>
															{file.fileType === 'pdf' ? (
																<Document
																	file={file.src}
																	error=""
																	loading={
																		<div className="loading-indicator-fg">
																			<LoadingBar />
																		</div>
																	}
																>
																	<Page
																		pageNumber={1}
																		width={120}
																	/>
																</Document>
															) : null}
															<div
																className="uploaded-files-image-fg"
																onClick={() => {
																	this.setState({
																		showFileFile: file,
																		showFileSrc: file.src,
																		showFileModal: true,
																	});
																}}
															>
																<div className="uploaded-files-text">
																	{file.originalFileName}
																</div>
																<div className="uploaded-lower-details">
																	<span className="size-indicator">
																		{prettyBytes(
																			file.originalFileSizeInMb,
																		)}
																	</span>
																	<span
																		className="delete-icn"
																		onClick={(e) => {
																			e.stopPropagation();
																			this.handleDeleteFile(
																				index,
																			);
																		}}
																	>
																		<DeleteIcon />
																	</span>
																</div>
															</div>
														</div>
													);
												},
											)}
										</>
										{this.state.isReadyFilesLoaded &&
										!this.state.isFileLoading ? (
											<>
												{_.map(this.state.fileUpload, (file, index) => {
													if (file.isSuccess === true) {
														return null;
													}
													return (
														<div
															className="uploaded-files-image-bg"
															key={`spodfj3489usiodjejfhois1s${index}`}
															style={
																file.type === 'pdf'
																	? {}
																	: {
																			backgroundImage: `url(${file.src})`,
																	  }
															}
														>
															{file.type === 'pdf' ? (
																<Document
																	file={file.src}
																	error=""
																	loading={
																		<div className="loading-indicator-fg">
																			<LoadingBar />
																		</div>
																	}
																>
																	<Page
																		pageNumber={1}
																		width={120}
																	/>
																</Document>
															) : null}
															<div
																className="uploaded-files-image-fg"
																onClick={() => {
																	this.setState({
																		showFileFile: file,
																		showFileSrc: file.src,
																		showFileModal: true,
																	});
																}}
															>
																<div className="uploaded-files-text">
																	{file.originalFileName}
																</div>
																<div className="uploaded-lower-details">
																	<span className="size-indicator">
																		{prettyBytes(
																			file.originalFileSizeInMb,
																		)}
																	</span>
																	<span
																		className="delete-icn"
																		onClick={(e) => {
																			e.stopPropagation();
																			this.handleDeleteUploadReadyFile(
																				index,
																			);
																		}}
																	>
																		<DeleteIcon />
																	</span>
																</div>
															</div>
														</div>
													);
												})}
											</>
										) : null}
										{this.state.isFileLoading ? (
											<>
												{_.map(this.state.fileUpload, (file, index) => {
													if (file.isSuccess === true) {
														return null;
													}
													return (
														<div
															className="uploaded-files-image-bg"
															style={
																file.type === 'pdf'
																	? {}
																	: {
																			backgroundImage: `url(${file.src})`,
																	  }
															}
														>
															{file.type === 'pdf' ? (
																<Document
																	file={file.src}
																	error=""
																	loading={
																		<div className="loading-indicator-fg">
																			<LoadingBar />
																		</div>
																	}
																>
																	<Page
																		pageNumber={1}
																		width={120}
																	/>
																</Document>
															) : (
																<div className="loading-indicator-fg">
																	<LoadingBar />
																</div>
															)}
														</div>
													);
												})}
											</>
										) : null}
										{this.state.uploadFileErrorCount +
											this.state.totalSignedUrlErrorCount >
										0 ? (
											<div className="upload-error-text">
												{this.state.uploadFileErrorCount +
													this.state.totalSignedUrlErrorCount}{' '}
												attachment failed to upload, try again
											</div>
										) : null}
									</div>
								</div>
								<div className="project-add-edit-popup-body-item" id={'notes'}>
									<div className="popup-body-title">NOTES</div>
									{_.map(
										this.props.activeExpenseID !== null
											? this.state.editExpenseDetails.notes
											: this.state.notes,
										(note, key) => {
											return (
												<div
													key={`ksdjio3289egu889${key}`}
													className="notes-item-container"
												>
													<InputHeader
														textarea={true}
														type="text"
														isInputError={false}
														label={
															(note.updatedBy !== null &&
															_.filter(this.props.tenantUsersList, {
																id: note.updatedBy,
															}).length > 0
																? `by ${
																		_.filter(
																			this.props
																				.tenantUsersList,
																			{
																				id: note.updatedBy,
																			},
																		)[0].firstName +
																		(_.filter(
																			this.props
																				.tenantUsersList,
																			{
																				id: note.updatedBy,
																			},
																		)[0].lastName
																			? ' ' +
																			  _.filter(
																					this.props
																						.tenantUsersList,
																					{
																						id: note.updatedBy,
																					},
																			  )[0].lastName
																			: '')
																  },`
																: note.createdBy !== null &&
																  _.filter(
																		this.props.tenantUsersList,
																		{
																			id: note.createdBy,
																		},
																  ).length > 0
																? `by ${
																		_.filter(
																			this.props
																				.tenantUsersList,
																			{
																				id: note.createdBy,
																			},
																		)[0].firstName +
																		(_.filter(
																			this.props
																				.tenantUsersList,
																			{
																				id: note.createdBy,
																			},
																		)[0].lastName
																			? ' ' +
																			  _.filter(
																					this.props
																						.tenantUsersList,
																					{
																						id: note.createdBy,
																					},
																			  )[0].lastName
																			: '')
																  },`
																: '') +
															(note.updatedAt !== null
																? ` ${moment
																		.unix(note.updatedAt)
																		.format(
																			'D MMM YYYY h:mm a',
																		)}`
																: note.createdAt !== null
																? ` ${moment
																		.unix(note.createdAt)
																		.format(
																			'D MMM YYYY h:mm a',
																		)}`
																: '')
														}
														onChange={(e) =>
															this.handleEditNote(e, key)
														}
														onBlur={(e) => {
															if (
																this.props.activeExpenseID !== null
															) {
																this.handleBlurEditNote(
																	e,
																	key,
																	note,
																	this.state.editExpenseDetails
																		.id,
																);
															}
														}}
														value={note.message}
													/>
													<div
														className="right-delete-container"
														onClick={(e) =>
															this.deleteEditNote(
																e,
																key,
																this.state.editExpenseDetails.id,
																note,
															)
														}
													>
														<DeleteIcon />
													</div>
												</div>
											);
										},
									)}
									{_.map(this.state.newAddedNote, (note, key) => {
										return (
											<div className="notes-item-container">
												<InputHeader
													textarea={true}
													type="text"
													isInputError={false}
													label={
														(_.filter(this.props.tenantUsersList, {
															id: this.state.userId,
														}).length > 0
															? `by ${
																	_.filter(
																		this.props.tenantUsersList,
																		{
																			id: this.state.userId,
																		},
																	)[0].firstName +
																	(_.filter(
																		this.props.tenantUsersList,
																		{
																			id: this.state.userId,
																		},
																	)[0].lastName
																		? ' ' +
																		  _.filter(
																				this.props
																					.tenantUsersList,
																				{
																					id: this.state
																						.userId,
																				},
																		  )[0].lastName
																		: '')
															  },`
															: '') +
														` ${moment(new Date()).format(
															'D MMM YYYY h:mm a',
														)}`
													}
													onChange={(e) => this.handleAddNote(e, key)}
													value={note.message}
												/>
												<div
													className="right-delete-container"
													onClick={(e) => this.deleteNewNote(e, key)}
												>
													<DeleteIcon />
												</div>
											</div>
										);
									})}
									<div className="notes-item-container">
										<InputHeader
											textarea={true}
											type="text"
											isInputError={false}
											label="New note"
											onChange={(e) => {
												this.setState({ storedNote: e.target.value });
											}}
											value={this.state.storedNote}
											onBlur={(e) => {
												if (e.target.value !== '') {
													this.addNote(e, this.props.activeExpenseID);
													this.setState({ storedNote: '' });
												}
											}}
										/>
									</div>
								</div>
								{(this.props.activeExpenseID === null &&
									(this.state.type === 'accomodation' ||
										this.state.type === 'travelFlight' ||
										this.state.type === 'travelBus')) ||
								(this.props.activeExpenseID !== null &&
									(this.state.editExpenseDetails.type === 'accomodation' ||
										this.state.editExpenseDetails.type === 'travelFlight' ||
										this.state.editExpenseDetails.type === 'travelBus')) ? (
									<div
										className="project-add-edit-popup-body-item"
										id={'bookingDetails'}
									>
										<div className="popup-body-title">BOOKING DETAILS</div>
										<InputHeader
											type="text"
											name="bookingID"
											isInputError={this.state.bookingIDError}
											label="Booking ID"
											value={
												this.props.activeExpenseID == null
													? this.state.bookingID
													: this.state.editExpenseDetails.metaData
															.bookingID
											}
											onChange={(e) => this.handleEventChange(e, 'bookingID')}
											errorMessage={this.state.bookingIDErrorMessage}
											required={true}
										/>
										<InputHeader
											type="text"
											name="numberOfTravellers"
											isInputError={this.state.numberOfTravellersError}
											label="No. of Travellers"
											value={
												this.props.activeExpenseID == null
													? this.state.numberOfTravellers
													: this.state.editExpenseDetails.metaData
															.numberOfTravellers
											}
											onChange={(e) =>
												this.handleEventChange(
													e.target.value === ''
														? 0
														: parseInt(
																e.target.value.replace(/,/g, ''),
														  ),
													'numberOfTravellers',
												)
											}
											errorMessage={this.state.numberOfTravellersErrorMessage}
											required={true}
										/>
										<div className="floating-select-container">
											<label>
												Booked Via
												<span className="required-input-new">*</span>
											</label>
											<Select
												className={'cost-select-container zIndex6 w-100p'}
												classNamePrefix="cost-select"
												options={this.state.bookedViaOptions}
												onChange={(e) =>
													this.handleEventChange(e, 'bookedVia')
												}
												defaultValue={_.find(this.state.bookedViaOptions, {
													value:
														this.props.activeExpenseID === null
															? this.state.bookedVia
															: this.state.editExpenseDetails.metaData
																	.bookedVia,
												})}
												isSearchable={false}
											/>
										</div>
										<DatePicker
											selected={
												this.props.activeExpenseID == null
													? this.state.travelDate == null
														? null
														: moment(
																this.state.travelDate.toString(),
																'YYYYMMDD',
														  ).toDate()
													: this.state.editExpenseDetails.metaData
															.travelDate &&
													  this.state.editExpenseDetails.metaData
															.travelDate !== null
													? moment(
															this.state.editExpenseDetails.metaData.travelDate.toString(),
															'YYYYMMDD',
													  ).toDate()
													: null
											}
											onChange={(e) =>
												this.handleEventChange(e, 'travelDate')
											}
											dateFormat="dd MMM yyyy"
											//placeholderText="dd / mm / yyyy"
											customInput={
												<CustomDateInput customLabel={'Travel Date'} />
											}
											wrapperClassName="w-100p"
											openToDate={new Date()}
										/>
										<InputHeader
											type="text"
											name="travelFrom"
											isInputError={this.state.travelFromError}
											label="From"
											value={
												this.props.activeExpenseID == null
													? this.state.travelFrom
													: this.state.editExpenseDetails.metaData.from
											}
											onChange={(e) =>
												this.handleEventChange(e, 'travelFrom')
											}
											errorMessage={this.state.travelFromErrorMessage}
											required={true}
										/>
										<InputHeader
											type="text"
											name="travelTo"
											isInputError={this.state.travelToError}
											label="To"
											value={
												this.props.activeExpenseID == null
													? this.state.travelTo
													: this.state.editExpenseDetails.metaData.to
											}
											onChange={(e) => this.handleEventChange(e, 'travelTo')}
											errorMessage={this.state.travelToErrorMessage}
											required={true}
										/>
										<InputHeader
											type="text"
											name="ticketPrice"
											isInputError={this.state.ticketPriceError}
											label="Ticket Price"
											value={this.formatCurrency(
												'inr',
												this.props.activeExpenseID == null
													? this.state.ticketPrice
													: this.state.editExpenseDetails.metaData
															.ticketPrice,
											)}
											onChange={(e) =>
												this.handleEventChange(
													e.target.value === ''
														? 0
														: parseInt(
																e.target.value.replace(/,/g, ''),
														  ),
													'ticketPrice',
												)
											}
											errorMessage={this.state.ticketPriceErrorMessage}
											required={true}
										/>
										{(this.props.activeExpenseID === null &&
											this.state.status === 'cancelled') ||
										(this.props.activeExpenseID !== null &&
											this.state.editExpenseDetails.metaData.status ===
												'cancelled') ? (
											<>
												<InputHeader
													type="text"
													name="refundAmount"
													isInputError={this.state.refundAmountError}
													label="Refund Amount"
													value={this.formatCurrency(
														'inr',
														this.props.activeExpenseID == null
															? this.state.refundAmount
															: this.state.editExpenseDetails.metaData
																	.refundAmount,
													)}
													onChange={(e) =>
														this.handleEventChange(
															e.target.value === ''
																? 0
																: parseInt(
																		e.target.value.replace(
																			/,/g,
																			'',
																		),
																  ),
															'refundAmount',
														)
													}
													errorMessage={
														this.state.refundAmountErrorMessage
													}
													required={true}
													disabled={
														this.props.activeExpenseID === null
															? this.state.ticketPrice === null ||
															  this.state.ticketPrice ===
																	undefined ||
															  isNaN(
																	parseInt(
																		this.state.ticketPrice,
																	),
															  )
															: this.state.editExpenseDetails.metaData
																	.ticketPrice === null ||
															  this.state.editExpenseDetails.metaData
																	.ticketPrice === undefined ||
															  isNaN(
																	parseInt(
																		this.state
																			.editExpenseDetails
																			.metaData.ticketPrice,
																	),
															  )
													}
												/>
												<InputHeader
													type="text"
													name="lossAmount"
													isInputError={false}
													label="Loss Amount"
													value={this.formatCurrency(
														'inr',
														this.props.activeExpenseID == null
															? this.state.lossAmount
															: this.state.editExpenseDetails.metaData
																	.lossAmount,
													)}
													onChange={(e) => {}}
													errorMessage={''}
													readOnly={true}
													required={true}
												/>
											</>
										) : null}
										<div className="floating-select-container">
											<label>
												Status
												<span className="required-input-new">*</span>
											</label>
											<Select
												className={'cost-select-container zIndex6 w-100p'}
												classNamePrefix="cost-select"
												options={this.state.statusOptions}
												onChange={(e) =>
													this.handleEventChange(e, 'status')
												}
												defaultValue={_.find(this.state.statusOptions, {
													value:
														this.props.activeExpenseID === null
															? this.state.status
															: this.state.editExpenseDetails.metaData
																	.status,
												})}
												isSearchable={false}
											/>
										</div>

										<InputHeader
											type="text"
											name="metaNotes"
											isInputError={false}
											label="Notes"
											value={
												this.props.activeExpenseID == null
													? this.state.metaNotes
													: this.state.editExpenseDetails.metaData.notes
											}
											onChange={(e) => this.handleEventChange(e, 'metaNotes')}
										/>
									</div>
								) : null}
							</div>
							<div className="bottom-popup-action-container">
								<span
									className="cancel-btn"
									onClick={() => this.handleCloseModal()}
								>
									Cancel
								</span>
								{this.state.disabledBtn ? (
									''
								) : (
									<span
										className={
											this.isDisabled()
												? 'add-edit-btn disabled'
												: 'add-edit-btn'
										}
										onClick={(e) => {
											if (!this.isDisabled()) {
												this.setState({ disabledBtn: true }, () => {
													this.handleAddEditExpense();
												});
											}
										}}
									>
										<span className="plus-icn">
											<PlusIcon />
										</span>
										<span>
											{this.props.activeExpenseID === null
												? 'Create Expense'
												: 'Save Expense'}
										</span>
									</span>
								)}
							</div>
						</div>
						<Modal
							handleClose={() =>
								this.setState({ showDeleteConfirmationModal: false })
							}
							show={this.state.showDeleteConfirmationModal}
							modalType={'center'}
						>
							<div className="center-confirm-delete-new">
								<div className="delete-modal-header">DELETE EXPENSE</div>
								<div className="middle-delete-container">
									<div className="middle-text">Are you sure?</div>
									<div className="middle-desc">
										Once deleted, you cannot undo this action
									</div>
								</div>
								<div className="bottom-delete-btns">
									<span
										className="cancel-btn"
										onClick={(e) =>
											this.setState({ showDeleteConfirmationModal: false })
										}
									>
										No, cancel
									</span>
									<span
										className="delete-btn"
										onClick={(e) => this.handleDelete(e)}
									>
										Yes, delete
									</span>
								</div>
							</div>
						</Modal>
						<Modal
							handleClose={() => this.setState({ showFileModal: false })}
							show={this.state.showFileModal}
							modalType={'center'}
						>
							<ShowFileModal
								handleClose={() => this.setState({ showFileModal: false })}
								file={this.state.showFileFile}
								fileSrc={this.state.showFileSrc}
							/>
						</Modal>
						<Modal
							handleClose={() => this.setState({ showDiscardModal: false })}
							show={this.state.showDiscardModal}
							modalType={'center'}
						>
							<div className="center-confirm-delete-new">
								<div className="delete-modal-header">DISCARD CHANGES</div>
								<div className="middle-delete-container">
									<div className="middle-text">Are you sure?</div>
									<div className="middle-desc">
										If you discard this information, you cannot undo this
									</div>
								</div>
								<div className="bottom-delete-btns">
									<span
										className="cancel-btn"
										onClick={(e) => this.setState({ showDiscardModal: false })}
									>
										No, Cancel
									</span>
									<span
										className="delete-btn"
										onClick={(e) => {
											this.props.handleClose();
											this.setState({ showDiscardModal: false });
										}}
									>
										Yes, Discard
									</span>
								</div>
							</div>
						</Modal>
					</>
				)}
			</Modal>
		);
	}
}

export default withRouter(CreateExpense);
